export default {
  addVariantToCart: 'Gerät dem Warenkorb hinzugefügt',
  addCustomProductToCart: 'Produkt dem Warenkorb hinzugefügt',
}
